import React from 'react';

import './style.css';

const spinner = () => <div className="Loader">Loading...</div>;

export default spinner;
